import moment from 'moment'

export function localDate(v) {
  return moment(v * 1000).format('YYYY-MM-DD')
}
export function localDateTime(v) {
  return moment(v * 1000).format('YYYY-MM-DD HH:mm:ss')
}
export function orderToday(v) {
  return moment(v).format('YY-MM-DD')
}
export function strISODate(v) {
  return moment(v).format('YYYY-MM-DD')
}
export function datetime(v) {
  return moment(v).format('YYYY-MM-DD HH:mm:ss')
}
export function formatSecond(v) {
  if (v < 60) {
    return `${v}秒`
  }
  if (v < 3600) {
    return `${(v / 60).toFixed()}分钟`
  }
  if (v <= 86400) {
    return `${(v / 3600).toFixed()}小时`
  }
  const remain = v % 86400
  if (remain / 3600 > 1) {
    return `${(v / 86400).toFixed()}天${(remain / 3600).toFixed()}小时`
  }
  return `${(v / 86400).toFixed()}天`
}
export function calcTotal(f) {
  const start = moment(f.created_at)
  const end = f.status == 2 || f.status == 100 ? moment(f.updated_at) : moment()
  const diff = end.diff(start, 'seconds')
  return `${formatSecond(diff)}`
  // if (diff <= 86400) {
  //   return `累计用时：${(diff / 3600).toFixed()}小时`
  // }
  // const remain = diff % 86400
  // return `累计用时：${(diff / 86400).toFixed()}天${(remain / 3600).toFixed()}小时`
}

export function calcPercent(state) {
  if (state == 0) {
    return 5
  } else if (state == 1) {
    return 10
  } else {
    return 100
  }
}
const urgency = { '1': '紧急', '2': '重要', '3': '一般' }
export function missionType(key) {
  return urgency[key]
}
export function filename(url) {
  return url.substring(url.lastIndexOf('/') + 1)
}
const OrderStatus = { '0': '线上', '1': '安装', '2': '测量' }
export function orderState(sta) {
  return OrderStatus[sta]
}
const tapeStatus = { '0': '选图', '3': '生产', '5': '已发货', '6': '已到店', '7': '待安装', '9': '完工' }
export function tapeState(sta) {
  return tapeStatus[sta]
}
export function tapeStates(){
  return Object.keys(tapeStatus).map(k => ({val:k,label:tapeState(k)})) 
}

const tapeProjectType = { '0': '管理员', '8': '店铺' }
export function tapeType(state) {
  return tapeProjectType[state] || '未知'
}